export default __webpack_public_path__ + "static/9_24-e4559fce3dafbf835e5c5ca3beda45a8.png";